import './Footer.css'


export default function Footer(){
  return(
<footer className="App-footer">
        © 2023 SONAIA LLC. All rights reserved.
      </footer>
  )
}